module.exports = __webpack_public_path__ + "static/media/building1.66b894a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/building1.png
// module id = 68
// module chunks = 0